export default __webpack_public_path__ + "media/storefront/features/hymns/hymns/Spain-2009240dbb4b59f48317d85dab96ec50.mp3";